import { UsersIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const CommunityBanner = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-slate-100/50 dark:bg-slate-900/50">
      <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3 truncate">
            <span className="rounded-lg bg-white/80 p-2 shadow-sm ring-1 ring-slate-200 dark:bg-slate-800/80 dark:ring-slate-700">
              <UsersIcon className="size-6 text-slate-600 dark:text-slate-300" aria-hidden="true" />
            </span>
            <p className="truncate font-medium text-slate-600 dark:text-slate-300">
              <span className="sm:hidden">{t("banner.community.short")}</span>
              <span className="hidden sm:inline" title={t("banner.community.long")}>
                {t("banner.community.long")}
              </span>
            </p>
          </div>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
            <Link
              to="https://amplexor.sharepoint.com/:f:/s/AcoladAmplexorVendorTrainingCenter/EoCRtUf1CCNMjsjthxM8pDABYsoWTfa0aYlf_qAlsfOq5w?e=SVUWhX&xsdata=MDV8MDJ8fGVlMzkwNjk5ZGI1MDQxYTE2Mzg0MDhkZDdkYjAyMTdmfDJmNDM2MTMwYmQ5MTRjZmJiMjE2YTkxMjcwMjBlNTU5fDB8MHw2Mzg4MDQ5MTc2MDE5MjEyMTJ8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=NkR5ZDlrTG5tbStVTHVuRUsrUzI0K09YMGlOVlU5VmliYzZWR2tBeHlDMD0%3d"
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-full items-center justify-center text-nowrap rounded-md bg-ribbon-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-ribbon-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ribbon-600 dark:bg-ribbon-500 dark:hover:bg-ribbon-400 sm:w-auto"
            >
              {t("banner.community.training")}
            </Link>
            <Link
              to="https://www.acolad.com/en/about/community.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-full items-center justify-center text-nowrap rounded-md bg-white px-3 py-2 text-sm font-semibold text-slate-600 shadow-sm ring-1 ring-inset ring-slate-200 hover:bg-slate-50 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700 dark:hover:bg-slate-700 sm:w-auto"
            >
              {t("banner.community.community")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
